<template>
  <b-card>
    <b-row class="justify-content-between px-1 align-items-center">
      <div v-if="loading" class="text-info d-flex align-items-center">
        <b-spinner
          style="width: 1.5rem; height: 1.5rem"
          class="mx-50"
          variant="info"
        />
        <div>جار التحميل ...</div>
      </div>
      <div v-else>
        <h4>{{ incentive.name }}</h4>
        <small>{{
          incentive.incentiveType ? incentive.incentiveType.name_ar : ""
        }}</small>
      </div>
    </b-row>
    <hr />
    <b-row v-if="incentive.read_at && !loading">
      <b-col>
        <InfoCard label="الاسم" :value="incentive.name" />
        <InfoCard label="النوع" :value="incentive.incentiveType.name_ar" />
        <InfoCard label="رقم القرار" :value="incentive.decision_no" />
        <InfoCard label="تاريخ القرار" :value="incentive.decision_date" />
        <InfoCard
          label="شوهد بتاريخ"
          :value="formatDateToHuman(incentive.read_at)"
        />
      </b-col>
      <b-col>
        <FileViewer style="height: 50rem" :fileEp="incentive.source" />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import InfoCard from "@/components/InfoCard.vue";
import { BSpinner, BCard, BRow, BCol } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import { formatDateToHuman } from "@core/utils/filter";
import FileViewer from "@/components/file-viewer";

export default {
  components: {
    BSpinner,
    BCard,
    BRow,
    BCol,
    InfoCard,
    FileViewer,
  },
  props: {
    id: String | Number,
  },
  methods: {
    formatDateToHuman,
    ...mapActions("MinistryRelation/Incentives", ["getIncentive"]),
  },
  computed: {
    ...mapGetters("MinistryRelation/Incentives", ["incentive", "loading"]),
  },
  created() {
    this.getIncentive(this.id);
  },
};
</script>
